import { render, staticRenderFns } from "./LgNote.vue?vue&type=template&id=43666850&"
import script from "./LgNote.vue?vue&type=script&lang=js&"
export * from "./LgNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports